import { observer } from "mobx-react-lite";

import { InlineNode } from "@/components/expression/InlineNode";
import { useNodeStyle } from "@/components/expression/utils/NodeStyleProvider";
import { useNodeHover } from "@/components/expression/utils/useNodeHover";
import { isFunctionOperatorParameterChild } from "@/models/nodes/utils";
import { twMerge } from "@/utils/twMerge";

import type { ExpressionComponent } from "./types";

/**
 * Currently unused
 */
export const PrefixOperatorNode: ExpressionComponent<"operator"> = observer(
  function PrefixOperatorNode({ node, className }) {
    const { isHovered, handlerProps } = useNodeHover(node, { index: 0 });
    const { parameters, doc } = node;
    const isSelected = doc.selection.isSelected(node.nodes[0]);
    const isActive = doc.selection.isActive(node.nodes[0]);
    const isFuncParameterChild = isFunctionOperatorParameterChild(node);
    const { debugOutlineNodes } = useNodeStyle();

    return (
      <div
        className={twMerge(
          "block align-baseline whitespace-nowrap rounded-lg min-w-[20px]",
          isFuncParameterChild && "min-w-0",
          debugOutlineNodes && "border p-1",
          className,
        )}
      >
        <div className="inline-block align-baseline">
          <div
            {...handlerProps}
            className={twMerge(
              "border border-transparent rounded-md w-5.5 text-center",
              isFuncParameterChild &&
                "w-auto rounded-none text-[12px]/[12px] text-function-parameter",
              isSelected && "bg-selected-bg text-selected-fg",
              isHovered && "border-hover-border hover-transition",
              isActive && "border-edit-border",
            )}
          >
            {node.operatorSymbol}
          </div>
        </div>
        {parameters[0] && (
          <div className="inline-block align-baseline">
            <InlineNode node={parameters[0]} />
          </div>
        )}
      </div>
    );
  },
);
